import { apiRequest } from './client'
import type {
  DropOpenResponse,
  DropPhysicalCheckoutRequest,
  DropPhysicalCheckoutResponse,
  DropPhysicalWinsResponse,
  DropRecentWinnersResponse,
  DropStatusResponse,
} from '../types/drops'

export function getDailyDrop(_signal?: AbortSignal): Promise<DropStatusResponse> {
  return apiRequest<DropStatusResponse>('/api/v1/drops/daily', { signal: _signal })
}

export function getRecentDrops(_signal?: AbortSignal): Promise<DropRecentWinnersResponse> {
  return apiRequest<DropRecentWinnersResponse>('/api/v1/drops/recent', { signal: _signal })
}

export function getPhysicalDropWinners(_signal?: AbortSignal): Promise<DropRecentWinnersResponse> {
  return apiRequest<DropRecentWinnersResponse>('/api/v1/drops/physical-winners', { signal: _signal })
}

export function getMyPhysicalDropWins(_signal?: AbortSignal): Promise<DropPhysicalWinsResponse> {
  return apiRequest<DropPhysicalWinsResponse>('/api/v1/drops/my-physical-wins', { signal: _signal })
}

export function checkoutPhysicalDropWin(
  openId: number,
  payload: DropPhysicalCheckoutRequest,
): Promise<DropPhysicalCheckoutResponse> {
  return apiRequest<DropPhysicalCheckoutResponse>(
    `/api/v1/drops/physical-wins/${openId}/checkout`,
    { method: 'POST', body: JSON.stringify(payload) },
  )
}

export function openDrop(_options?: unknown): Promise<DropOpenResponse> {
  return apiRequest<DropOpenResponse>('/api/v1/drops/open', { method: 'POST' })
}

